import { useTranslation } from "react-i18next";

export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <section className="mx-auto max-w-lg p-8">
      <h1 className="text-2xl font-semibold">{t("pages.noAccessTitle")}</h1>
      <p className="mt-2 text-muted">{t("pages.noAccessBody")}</p>
    </section>
  );
}
